import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC } from 'react';
import { ErrorMessage } from '../../../Shared/Shared';
import { FORM_RADIO_COMPONENT_TYPES, FORM_RADIO_TYPES, FormDateAndTime } from '../../types';
import {
  BookingButton,
  BookingButtonBackgroud,
  BookingButtonContainer,
  CalendarDayLabel,
  FormDateContainer,
  FormDateLabel,
  FormDateLabelContainer,
  FormMonths,
  FormMonthsContainer
} from '../Date/styled';

type DaySlot = {
  day: string;
  available: number;
  times: string[];
};
interface FormRadioDaysProps {
  type: keyof typeof FORM_RADIO_COMPONENT_TYPES;
  formOptions: FormDateAndTime;
  session: number;
  days: DaySlot[];
  loading: boolean;
}

const FormRadioDays: FC<FormRadioDaysProps> = ({ type, formOptions, session, days, loading }) => {
  const { t } = useTranslation();
  const { registerAs } = FORM_RADIO_COMPONENT_TYPES[type];
  const requiredMessage = t(FORM_RADIO_COMPONENT_TYPES[type].requiredMessage);
  const errorMessage = t(FORM_RADIO_COMPONENT_TYPES[type].errorMessage);
  const { formState, register, watch } = formOptions;

  const watchedForm = (watch(registerAs) as string[][]) || [];
  const watchedDays = watchedForm?.[session] || [];

  const isRecurring = type === FORM_RADIO_TYPES.DAYS;

  const checkIfDayIsAvailable = (option: DaySlot) => {
    const { day, available, times } = option;

    if (loading || available === 0) {
      return false;
    }

    const otherSelectedDays = watchedDays?.filter((d: string) => d !== day);
    const otherSelectedDaysTimes = otherSelectedDays?.map((day: string) => days.find(({ day: d }) => d === day)?.times || []);

    if (!otherSelectedDays?.length) {
      return true;
    }

    return times.some(time => otherSelectedDaysTimes?.every(times => times?.includes(time)));
  };

  return (
    <>
      <FormMonthsContainer center={isRecurring}>
        <FormMonths>
          <FormDateContainer>
            <FormDateLabelContainer isRecurring>
              {days.map(option => {
                const { day } = option;
                const traslatedDay = t(`daysShort.${day}`);
                const isDisabled = !checkIfDayIsAvailable(option);
                return (
                  <FormDateLabel key={day}>
                    <input
                      {...register(`${registerAs}.${session}`, {
                        required: requiredMessage
                      })}
                      type="checkbox"
                      value={day}
                      disabled={isDisabled}
                    />

                    <BookingButtonContainer>
                      <BookingButtonBackgroud>
                        <BookingButton disabled={isDisabled} bigCircle>
                          <CalendarDayLabel>{traslatedDay}</CalendarDayLabel>
                        </BookingButton>
                      </BookingButtonBackgroud>
                    </BookingButtonContainer>
                  </FormDateLabel>
                );
              })}
            </FormDateLabelContainer>
          </FormDateContainer>
        </FormMonths>
      </FormMonthsContainer>
      {formState?.errors?.[registerAs] && <ErrorMessage>{`${formState?.errors?.[registerAs]?.message || errorMessage}`}</ErrorMessage>}
    </>
  );
};

export default FormRadioDays;
